import React from 'react';

const Social = () => {
    return(
        <div className="home__social">
            <a href="#skills" className="home__social-icon">
                <i className="bx bxl-mongodb"></i>
            </a>
            <a href="#skills" className="home__social-icon">
                <i className="bx bxl-nodejs"></i>
            </a>
            <a href="#skills" className="home__social-icon">
                <i className="bx bxl-react"></i>
            </a>
            <a href="#skills" className="home__social-icon">
                <i className='bx bxl-flutter' ></i>
            </a>

        </div>
    );
}

export default Social;

<i class='bx bxl-mongodb'></i>